import type { SectionProps } from '@/components/sitemap/Section';
import { sharedConfig } from '@/pageConfig/shared';
import sections from '@/static/sitemap.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  section: SectionProps[];
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    metaTitle: 'HTML Sitemap | Lemonade Insurance',
    description:
      'Easily access the main pages of our website with this HTML sitemap. A simple way to navigate key pages in one place',
  },
  section: sections['en-US'],
};
